// extracted by mini-css-extract-plugin
export default {"content":"Auth_content__BXGrY"};